module.exports = __webpack_public_path__ + "static/media/294125.bb392780.png";